var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_3022",
    "data-name": "Groupe 3022",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54.179,
    height: 44.95,
    viewBox: "0 0 54.179 44.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_240",
    "data-name": "Rectangle 240",
    width: 54.179,
    height: 44.95,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3015",
    "data-name": "Groupe 3015",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36678",
    "data-name": "Trac\\xE9 36678",
    d: "M58.346,8.623A3.673,3.673,0,1,1,54.673,4.95a3.673,3.673,0,0,1,3.673,3.673",
    transform: "translate(-4.167 -0.405)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36679",
    "data-name": "Trac\\xE9 36679",
    d: "M58.346,17.623a3.673,3.673,0,1,1-3.673-3.673,3.673,3.673,0,0,1,3.673,3.673",
    transform: "translate(-4.167 -1.14)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36680",
    "data-name": "Trac\\xE9 36680",
    d: "M58.346,26.623a3.673,3.673,0,1,1-3.673-3.673,3.673,3.673,0,0,1,3.673,3.673",
    transform: "translate(-4.167 -1.876)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36681",
    "data-name": "Trac\\xE9 36681",
    d: "M7.346,8.623A3.673,3.673,0,1,1,3.673,4.95,3.673,3.673,0,0,1,7.346,8.623",
    transform: "translate(0 -0.405)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36682",
    "data-name": "Trac\\xE9 36682",
    d: "M7.346,17.623A3.673,3.673,0,1,1,3.673,13.95a3.673,3.673,0,0,1,3.673,3.673",
    transform: "translate(0 -1.14)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36683",
    "data-name": "Trac\\xE9 36683",
    d: "M7.346,26.623A3.673,3.673,0,1,1,3.673,22.95a3.673,3.673,0,0,1,3.673,3.673",
    transform: "translate(0 -1.876)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36684",
    "data-name": "Trac\\xE9 36684",
    d: "M24.548,40.95a3.673,3.673,0,1,1-3.673,3.673,3.673,3.673,0,0,1,3.673-3.673",
    transform: "translate(-1.706 -3.346)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36685",
    "data-name": "Trac\\xE9 36685",
    d: "M33.548,40.95a3.673,3.673,0,1,1-3.673,3.673,3.673,3.673,0,0,1,3.673-3.673",
    transform: "translate(-2.441 -3.346)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36686",
    "data-name": "Trac\\xE9 36686",
    d: "M45.528,35.813H9.715V0",
    transform: "translate(-0.794 0)",
    fill: "none",
    stroke: "#cea95a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36687",
    "data-name": "Trac\\xE9 36687",
    d: "M9.715,35.813H45.528V0",
    transform: "translate(-0.794 0)",
    fill: "none",
    stroke: "#cea95a",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.b0947c195bc8caef621e347a1921ed54.svg";
export { ForwardRef as ReactComponent };